import React from "react";
import EmptyPic from "../../../Assets/Image/png/empty.png";
import { BtnPrimary } from "../buttons/Btn";
import Card from "../cards/Card";

const EmptyCourseDash = (props) => {
    return (
        <Card>
            <div className=" pt-20 pb-24 px-[20rem] flex flex-col justify-center items-center">
                <h3 className="font-bold text-[1.6rem] text-purple-dark mb-20">
                    اطلاعات {props.name} بوت کمپ
                </h3>
                <div className="mb-4">
                    <img src={EmptyPic} alt="EmptyPic" />
                </div>
                <p className=" text-[1.8rem] mb-14">
                    هنوز {props.name} نساخته‌اید!
                </p>
                <BtnPrimary
                    text={`+ ساخت ${props.name} جدید`}
                    className=" py-11 px-[7.8rem]"
                    onClick={() => props.show(true)}
                />
            </div>
        </Card>
    );
};

export default EmptyCourseDash;
